import en from './en.json';
import hi from './hi.json';

// English + Hindi ship in the initial bundle. All other locales are loaded
// on demand to keep the first paint light (~300KB of JSON deferred).
export const translations = { en, hi };

const loaders = {
  es: () => import('./locales/es.json'),
  fr: () => import('./locales/fr.json'),
  de: () => import('./locales/de.json'),
  pt: () => import('./locales/pt.json'),
  ar: () => import('./locales/ar.json'),
  zh: () => import('./locales/zh.json'),
  ja: () => import('./locales/ja.json'),
  bn: () => import('./locales/bn.json'),
  mr: () => import('./locales/mr.json'),
  te: () => import('./locales/te.json'),
  ta: () => import('./locales/ta.json'),
  gu: () => import('./locales/gu.json'),
  kn: () => import('./locales/kn.json'),
  ml: () => import('./locales/ml.json'),
  pa: () => import('./locales/pa.json'),
  or: () => import('./locales/or.json'),
  ur: () => import('./locales/ur.json'),
};

export const loadLocale = async (code) => {
  if (translations[code]) return translations[code];
  const loader = loaders[code];
  if (!loader) return null;
  const mod = await loader();
  translations[code] = mod.default || mod;
  return translations[code];
};
